module.exports = __webpack_public_path__ + "86ed4592960b16a78c1dbd4bc1ab01b2.svg";


//////////////////
// WEBPACK FOOTER
// ./components/applications/income/main_logo.svg
// module id = 1099
// module chunks = 0